import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';

const Header = ({ view, setView, auth, onLogout, onChangeProfile, allowedViews }) => {
  const navigate = useNavigate();
  return (
    <div className="header">
      <div className="header-container">
        <div className="logo-section">
          <img src="/letracopagimnasta.png" alt="CopaGimnasta" className="logo-letras" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
        </div>
      </div>
    </div>
  );
};

export default Header;